import { render } from "./CorridoringControl.vue?vue&type=template&id=d8fc1e18"
import script from "./CorridoringControl.vue?vue&type=script&lang=js"
export * from "./CorridoringControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__